export const getDynamicDialogText = (category) => {
  return `This entity may be exempt under the ${category.categoryTitle} exemption. This is preliminary information based on your responses but should be verified by your legal counsel.`;
};

export let CompanyOverviewQuestions = [
  {
    order: 1,
    title:
      "Is this an entity that has been or will be registered to do business in the U.S. by the filing of a document with a Secretary of State (or similar agency) or Indian tribe?",
    selection: null,
    tooltil: "This includes a corporation, a limited liability company (LLC), or an entity that was otherwise created in the United States by filing a document with a Secretary of State or any similar office under the law of a state or Indian tribe.",
  },
  {
    order: 2,
    title: "Does this company have a physical operating presence in the U.S.?",
    selection: null,
    tooltil: "“Operating presence at a physical office within the United States” means that an entity regularly conducts its business at a physical location in the United States that the entity owns or leases and that is physically distinct from the place of business of any other unaffiliated entity.",
  },

  {
    order: 3,
    title: "Does this entity employ more than 20 full-time employees in the U.S.?",
    selection: null,
    tooltil: "Full-time employees on average work at least 30 hours per week or 130 hours per month.",
  },
  {
    order: 4,
    title:
      "Did this company report over $5,000,000 in gross receipts or sales on last year’s U.S. Federal income tax or information return?",
    selection: null,
    tooltil: "",
  }
];

export const InstructionDetail = `Complete our short wizard to determine if your entity is an eligible reporting company and if your company qualifies for one of the 23 exemptions provided in the Corporate Transparency Act.`;
export const StaticDialogText = `You do not appear to be a reporting company and may not need to file under the Corporate Transparency Act. The ultimate determination of reporting requirements should be made by your legal counsel`;
export const DynamicDialogText = `This entitiy may be exempt under the Securities Reporting Issuer exemption. This is preliminary information based on your responses, and should be verified by legal counsel.`;
export const DynamicDialogSubText = `Would you like to check if your company qualifies for any additional exemptions?`;
export const DynamicDialogYesButtonText = `Yes, More Exemptions`;
export const DynamicDialogNoButtonText = `No, Get Results`;

export const CompanyOverviewCategory = {
  categoryId: 100,
  categoryTitle: "Large Operating Company",
  selected: false,
  questions: CompanyOverviewQuestions,
};
